export default __webpack_public_path__ + "static/media/filledHeart.092d5caa.svg";